import { createClosingGame } from '../shared/closing-game.js';

export default createClosingGame({
    id: 'cricket',
    name: 'Cricket',
    description: 'Close 20 down to 15 and the bull by hitting each one three times, then keep scoring on the ones you\'ve closed - only for as long as you\'re still the only one who has. First to close everything, with the highest score, wins.',
    getTargets: () => [20, 19, 18, 17, 16, 15, 'bull'],
    // The moment a second player also closes a number, scoring on it shuts
    // off for everyone (including whoever closed it first) - see
    // closing-game.js's isSoleCloser.
    soleCloserScoring: true
});
